var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6602 9.44001L19.6802 13.62C18.8402 17.23 17.1802 18.69 14.0602 18.39C13.5602 18.35 13.0202 18.26 12.4402 18.12L10.7602 17.72C6.59018 16.73 5.30018 14.67 6.28018 10.49L7.26018 6.30001C7.46018 5.45001 7.70018 4.71001 8.00018 4.10001C9.17018 1.68001 11.1602 1.03001 14.5002 1.82001L16.1702 2.21001C20.3602 3.19001 21.6402 5.26001 20.6602 9.44001Z",
    stroke: "#86929D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0603 18.3901C13.4403 18.8101 12.6603 19.1601 11.7103 19.4701L10.1303 19.9901C6.16034 21.2701 4.07034 20.2001 2.78034 16.2301L1.50034 12.2801C0.220341 8.3101 1.28034 6.2101 5.25034 4.9301L6.83034 4.4101C7.24034 4.2801 7.63034 4.1701 8.00034 4.1001C7.70034 4.7101 7.46034 5.4501 7.26034 6.3001L6.28034 10.4901C5.30034 14.6701 6.59034 16.7301 10.7603 17.7201L12.4403 18.1201C13.0203 18.2601 13.5603 18.3501 14.0603 18.3901Z",
    stroke: "#86929D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6396 7.52979L16.4896 8.75979",
    stroke: "#86929D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6602 11.3999L13.5602 12.1399",
    stroke: "#86929D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.276a5dbebad5369970b8c8d3753ded6a.svg";
export { ForwardRef as ReactComponent };